import React, {
  useState,
  useMemo,
  useEffect,
  useRef,
  ReactNode,
  forwardRef,
} from 'react';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import LS from '@/styles/layoutStyled';
import CS from '@/styles/componentStyled';
import BS from '@/styles/btnStyled';
import IS from '@/styles/inputStyled';
import TitleTextBox from '@/component/TitleTextBox';
import Pagenation from '@/component/Pagenation';
import { ApexOptions } from 'apexcharts';
import ApexCharts from 'react-apexcharts';
import {
  Map,
  MapMarker,
  MapTypeControl,
  ZoomControl,
} from 'react-kakao-maps-sdk';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import { JsonEditor } from 'json-edit-react';

const Test = () => {
  const [updateName, setUpdateName] = useState('');
  const [updateBoolean, setUpdateBoolean] = useState(false);

  const [jsonData, setJsonData] = useState<any>({
    name: '김경호',
    age: 29,
  });

  useEffect(() => {
    console.log(updateName);
    console.log(jsonData);
    if (updateName === 'city') {
      setJsonData((prevData: any) => ({
        ...prevData,
        city: '',
      }));
      setUpdateName('');
    }
    if (updateName === '건물') {
      setJsonData((prevData: any) => ({
        ...prevData,
        건물: {
          기울기: '',
          높이: 0,
          공사여부: false,
        },
      }));
      setUpdateName('');
    }
  }, [jsonData]);

  const lineSerise = [
    {
      name: 'value',
      data: [1, 2, 3],
    },
  ];
  const lineOptions: ApexOptions = {
    chart: {
      id: 'model-setup-chart',
      height: '18.4rem',
      width: '18.4rem',
      toolbar: {
        show: false,
      },
      background: 'transparent',
      animations: {
        enabled: true,
        easing: 'linear',
        speed: 1200,
        dynamicAnimation: {
          speed: 1000,
        },
      },
    },
    tooltip: {
      y: {
        formatter: (value) => `${value}`,
      },
    },
    dataLabels: {
      enabled: false,
    },
    fill: {
      type: 'gradient',
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.5,
        opacityTo: 0.8,
        stops: [0, 80, 100],
      },
    },
    colors: ['#4880FF'],
    xaxis: {
      axisBorder: { show: true },
      axisTicks: { show: false },
      labels: {
        show: true,
        style: {
          fontFamily: '"SpoqaHanSansNeo"',
          fontSize: '15px',
          fontWeight: '400',
        },
      },
      offsetX: -10,
      categories: [1, 2, 3],
    },
    grid: { show: false },
    stroke: {
      curve: 'smooth',
      width: 2,
    },
    yaxis: {
      show: true,
      axisBorder: { show: true },
      tickAmount: 2,
      min: 0,
      forceNiceScale: true,
      labels: {
        style: {
          fontFamily: '"SpoqaHanSansNeo"',
          fontSize: '13px',
          fontWeight: '300',
          colors: ['#999'],
        },
        offsetX: -10,
      },
    },
  };

  const handleTset = () => {
    console.log(jsonData);
  };

  return (
    <>
      <div>
        <JsonEditor
          data={jsonData}
          setData={setJsonData}
          rootName="model"
          theme="githubLight"
          onAdd={({ name }) => {
            if (name === 'city') setUpdateName('city');
            if (name === '건물') setUpdateName('건물');
          }}
        />
      </div>
      <CS.TableType1>
        <table>
          <thead>
            <tr>
              <th>No</th>
              <th>기기 이름</th>
              <th>감지 횟수</th>
              <th>최종 날짜</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>전자 제어</td>
              <td>3</td>
              <td>2024-10-11</td>
            </tr>
          </tbody>
        </table>
      </CS.TableType1>
      <ApexCharts
        type="area"
        height={'150'}
        series={lineSerise}
        options={lineOptions}
      />
      <button onClick={handleTset}>버튼</button>
    </>
  );
};

export default Test;
